import { StepDef, TestDef } from "../models.js";
import { getBlindMoveSetup } from "./commonSteps.js";
import cc_widgets from '../configChecker_widgets.js';
import { getMlConfig } from "../configState.js";


function getExitSequence(chooseMoveDirection) {
  const exitSequence = new StepDef( ({actuator, diagnose, pass, fail, runtime, notifier}) => {
    cc_widgets.StepWidgets.askChoice({ title: `Did the actuator "${actuator.parameters.friendlyName}" move?`, group: true }, ["Yes", "No", "Not sure, retry"], (answer) => {
      if (answer == 'Yes') {
        if (actuator.isMultiDrive()) {
          cc_widgets.StepWidgets.askChoice({ title: `Did any actuator, other than "${actuator.parameters.friendlyName}", move?` }, ["Yes", "No", "Not sure, retry"], (answer) => {
            if (answer == 'No') {
              pass(`The motors are correctly wired.`);
              actuator.driveNumberValidatable.isValid = true;
              notifier.finished();
            }
            else if (answer == 'Yes') {
              diagnose({
                error: `Some motors of the actuator "${actuator.parameters.friendlyName}" are driving another actuator.`,
                resolution: {
                  // TODO FUTURE : The drive numbers could be automatically determined by the software...
                  description: `In the "Drive" drop-down menu, remove some drive(s) to match how the motors are wired to the controller.`,
                  type: 'config',
                },
                errorCode: -1,
              });
              notifier.finished();
            }
            else { // NotSure
              runtime.ctx.isRetrying = false;
              runtime.runStep(chooseMoveDirection);
            }
          });
        }
        else {
          pass(`The motor is correctly wired.`);
          actuator.driveNumberValidatable.isValid = true;
          notifier.finished();
        }
      }
      else if (answer == 'No') {
        if (getMlConfig().getController().isHardware_1D()) {
          fail({
            message: `Actuator "${actuator.parameters.friendlyName}" may be overloaded, or not properly installed or configured.`,
            errorCode: -1,
          });
          notifier.finished();
        }
        else {
          cc_widgets.StepWidgets.askChoice({ title: `Did any actuator, other than "${actuator.parameters.friendlyName}", move?` }, ["Yes", "No", "Not sure, retry"], (answer) => {
            if (answer == 'No') {
              fail({
                message: `Actuator "${actuator.parameters.friendlyName}" may be overloaded, or not properly installed or configured.`,
                errorCode: -1,
              });
              notifier.finished();
            }
            else if (answer == 'Yes') {
              diagnose({
                error: `The configured drive numbers do not correspond to the motor wiring.`,
                resolution: {
                  description: `In the "Drive number" drop-down of the drive settings, change the drive numbers to match how the motors are wired to the controller.`,
                  type: "config",
                },
                errorCode: -1,
              });
              notifier.finished();
            }
            else { // NotSure
              runtime.ctx.isRetrying = false;
              runtime.runStep(chooseMoveDirection);
            }
          });
        }
      }
      else { // NotSure
        runtime.ctx.isRetrying = false;
        runtime.runStep(chooseMoveDirection);
      }
    });
  });
  return exitSequence;
}


export default new TestDef({
  info: {
    friendlyName: "Verify the drive number(s)", // "Jogging the actuator"
    precedence: 1,
    desc: 'To verify that the actuator is able to move, we will try to move it by a small distance. This will ensure that the configured drive number(s) correspond to the installed motor(s), and that their direction(s) are not fighting each other.',
  },
  entryStep: getBlindMoveSetup('driveNumber', getExitSequence),
  validatesOnSuccess: (actuator) => actuator.driveNumberValidatable,
});
